export function filterByName(original_list,condition,text){  //oldList原始列表，condition查询参,text查询内容
    let newList=[];
    if(text){
        newList=original_list.filter(e=>e.name.indexOf(text)!=-1)
    }else{
        newList=original_list
    }
	return newList
}

function isLargeTen(val) {
    return val < 10 ? '0' + val : val;
}
export function getTimeStamp(val){   //根据秒获取时间格式
    let str
    if(val&&val!=undefined){
        let hour=parseInt(val/3600)?parseInt(val/3600):0
        let minu=parseInt((val-parseInt(hour*3600))/60)?parseInt((val-parseInt(hour*3600))/60):0
        let seconds=parseInt(val-parseInt(hour*3600)-parseInt(minu*60))?parseInt(val-parseInt(hour*3600)-parseInt(minu*60)):0
        str=isLargeTen(hour)+':'+isLargeTen(minu)+':'+isLargeTen(seconds)
        return str
    }else{
        return str
    }
}

export default {
    filterByName,
    getTimeStamp
}



// WEBPACK FOOTER //
// ./src/utils/filter.js